import { ReactElement } from 'react';
import { RowNode } from 'ag-grid-community';

export const TrunkedCellRenderer = (value: RowNode): ReactElement => {
  return value.data.trunk?.enabled ? <span>&#x2713;</span> : <></>;
};
